import { lazy } from 'react'
import { Outlet } from 'react-router-dom'
import SuspenseWrapper from '@/components/common/wrappers/SuspenseWrapper.tsx'

const HelpIndex = lazy(() => import('@/help/view/HelpIndex.tsx'))
const HelpPage = lazy(() => import('@/help/view/HelpPage.tsx'))

export const HELP_ROUTES = {
  path: 'help',
  element: (
    <SuspenseWrapper type="nested">
      <Outlet />
    </SuspenseWrapper>
  ),
  children: [
    { index: true, element: <HelpIndex /> },
    { path: ':slug', element: <HelpPage /> },
  ],
}
